export const s3Config = {
    buckets: {
    'ap-southeast-2': 'i-ag.com.au-data'
    },
    defaultRegion: 'ap-southeast-2'
  };
  
